import { useMutation } from '@tanstack/react-query';
import * as qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import { getRequestParams } from '../helpers/getRequestParams';
import type { ICartRange, IFilter } from '../model/engagementFilter';

const exportEngagementReportFn = (params: {
  filter: IFilter;
  cartRange: ICartRange;
  locationIds: Array<number>;
  search: string;
  sorting: ITableSorting;
}) => {
  const { filterParams, sortParams } = getRequestParams({
    filter: params.filter,
    cartRange: params.cartRange,
    locationIds: params.locationIds,
    sorting: params.sorting,
  });

  const searchValue = params.search;

  return apiClient.get(`${APP_API_URL_V2}fsd/action-item/report/engagement-stats/action-list/export`, {
    params: { filter: filterParams, search: searchValue, sort: [sortParams] },
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
  });
};

export const useExportEngagementReportMutation = () => {
  return useMutation({
    mutationFn: exportEngagementReportFn,
  });
};
